import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate } from 'react-router-dom';
import TableContainer from './components/TableContainer';
import Pagination10 from './components/Pagination10';
import ResponsiveShadow from './components/ResponsiveShadow';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import ConfirmModal from './components/modals/ConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import usePagination10 from './components/hooks/usePagination10';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import DataTable from './components/DataTable';
import PaginationBar from './components/PaginationBar';
import UsuarioModal from './components/modals/UsuarioModal';

function Usuarios() {
  // ... todo o seu state, useEffects e funções (NÃO MUDA NADA AQUI) ...
  const [Usuarios, setUsuarios] = useState([]);
  const [atualizar, setAtualizar] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState(''); // Estado do filtro
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [modalUsuarioAberto, setModalUsuarioAberto] = useState(false);
  const [usuarioParaEditar, setUsuarioParaEditar] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const totalItems = Usuarios.length;
  const { setPagination } = usePagination10(totalItems);

  // Função para filtrar os fabricantes com base na busca
  const normalizeString = str => {
    if (!str) return '';
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  // Filtra os fabricantes com base no termo de busca
  const usuariosFiltrados = Usuarios.filter(usu => {
    const normalizedBusca = normalizeString(filtro);
    return (
      normalizeString(usu.nome).includes(normalizedBusca) ||
      normalizeString(usu.cpf).includes(normalizedBusca) ||
      normalizeString(usu.login).includes(normalizedBusca)
    );
  });

  const selectedUsuarios = usuariosFiltrados.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL.USUARIO}/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        setUsuarios(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter usuários:', error);
        navigate('/');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [atualizar]);

  function handleDelete(cpf) {
    showConfirmModal('delete', () => handleConfirmDelete(cpf));
  }

  function handleConfirmDelete(cpf) {
    const loggedUser = JSON.parse(localStorage.getItem('user'));
    const loggedUserCpf = loggedUser?.cpf;

    if (cpf === loggedUserCpf) {
      showDefaultModal('error', 'Você não pode excluir a si mesmo.');
      return;
    }

    axios
      .get(`${API_BASE_URL.USUARIO_BIND}/exists_cpf/` + cpf, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        if (result.data.exists) {
          showDefaultModal(
            'error',
            'Este usuário possui vínculos e não pode ser excluído. Exclua os vínculos antes de tentar novamente.'
          );
        } else {
          axios
            .delete(`${API_BASE_URL.USUARIO}/delete/` + cpf, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then(result => {
              setAtualizar(result);
              showDefaultModal(
                'success',
                'O registro foi excluído com sucesso!'
              );
            })
            .catch(error => {
              console.error('Erro ao excluir usuário:', error);
              showDefaultModal('error', 'Erro ao excluir o registro!');
            });
        }
      })
      .catch(error => {
        console.error('Erro ao verificar vínculos:', error);
        setTimeout(() => navigate('/'), 0);
      });
  }

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Usuários Cadastrados" icon="bi-people" />
        <PageContent>
          <div className="d-flex flex-column flex-lg-row justify-content-lg-between gap-2 mb-2 align-items-start align-items-lg-center">
            <div className="botao-grid-2col">
              <button
                className="btn btn-success btn-sm botao-igual d-inline-flex align-items-center"
                onClick={() => { setUsuarioParaEditar(null); setModalUsuarioAberto(true); }}
              >
                <i className="bi bi-plus-lg me-1" /> Novo
              </button>
              <button
                className="btn btn-primary btn-sm botao-igual"
                disabled={!usuarioSelecionado}
                onClick={() => {
                  if (usuarioSelecionado) {
                    setUsuarioParaEditar(usuarioSelecionado);
                    setModalUsuarioAberto(true);
                  }
                }}
                title="Editar usuário selecionado"
              >
                <i className="bi bi-pencil-square me-1"></i>
                Editar
              </button>
              <button
                className="btn btn-info btn-sm botao-igual"
                disabled={!usuarioSelecionado}
                onClick={() => {
                  if (usuarioSelecionado) {
                    navigate('/usuario_vinculos', {
                      state: { usuario: usuarioSelecionado },
                    });
                  }
                }}
                title="Vincular usuário selecionado"
              >
                <i className="bi bi-link-45deg me-1"></i>
                Vincular
              </button>
              <button
                className="btn btn-danger btn-sm botao-igual"
                disabled={!usuarioSelecionado}
                onClick={() => {
                  if (usuarioSelecionado) {
                    handleDelete(usuarioSelecionado.cpf);
                  }
                }}
                title="Excluir usuário selecionado"
              >
                <i className="bi bi-trash3 me-1"></i>
                Excluir
              </button>
            </div>
            <div className="mt-2 mt-lg-0">
              <div className="input-group input-group-sm">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Buscar por CPF, Nome ou Login"
                  value={filtro}
                  onChange={e => setFiltro(e.target.value.toUpperCase())}
                />
              </div>
            </div>
          </div>

          <TableContainer isLoading={isLoading}>
              <DataTable style={{ fontSize: '0.8rem' }} head={
                <tr>
                  <th scope="col">CPF</th>
                  <th scope="col">Nome</th>
                  <th scope="col">Login</th>
                  <th scope="col">Situação</th>
                </tr>}>
              <tbody>
                {selectedUsuarios.map(usu => (
                    <tr
                      key={usu.cpf}
                      className={
                        usuarioSelecionado && usuarioSelecionado.cpf === usu.cpf
                          ? 'table-primary'
                          : ''
                      }
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (
                          usuarioSelecionado &&
                          usuarioSelecionado.cpf === usu.cpf
                        ) {
                          setUsuarioSelecionado(null); // Desseleciona se já estiver selecionado
                        } else {
                          setUsuarioSelecionado(usu); // Seleciona o usuário
                        }
                      }}
                    >
                      <td>{usu.cpf}</td>
                      <td>{usu.nome}</td>
                      <td>{usu.login}</td>
                      <td>{usu.situacao}</td>
                    </tr>
                  ))}
              </tbody>
            </DataTable>
            </TableContainer>
        </PageContent>
        <PaginationBar setPagination={setPagination} />
        <ConfirmModal {...setConfirmModal} />
        <DefaultModal {...setDefaultModal} />
        <UsuarioModal
          isOpen={modalUsuarioAberto}
          onClose={() => { setModalUsuarioAberto(false); setUsuarioParaEditar(null); }}
          usuario={usuarioParaEditar}
          onSave={() => setAtualizar(prev => !prev)}
        />
      </ResponsiveShadow>
    </Layout>
  );
}

export default Usuarios;
